;(function () {
  'use strict'

  angular
    .module('contrast.rules')
    .controller('RulesDefaultCtrl', RulesDefaultCtrl)

  function RulesDefaultCtrl(
    $scope,
    $timeout,
    RulesService,
    PromiseService,
    ErrorService,
    FeaturesService,
    UserService,
    SERVER_ENVIRONMENT,
    AGENT_FEATURE,
    RULES_EXPAND_PROPERTIES
  ) {
    'ngInject'

    var _searchKeywords = ''

    // API
    angular.extend($scope, {
      searchKeywords: searchKeywords,
      loadRulesByScroll: loadRulesByScroll,
      order: order,
      changeStatus: changeStatus,
      quickFilterSelect: quickFilterSelect,
      restoreDefaults: restoreDefaults
    })

    function _setDefaults() {
      angular.extend($scope, {
        model: {
          rules: [],
          numPerLoad: 15,
          count: 0,
          busy: true,
          updating: false,
          filteredRules: [],
          row: 'title',
          quickFilters: [],
          selectedQuickFilter: {
            name: 'RECOMMENDED',
            filterType: 'RECOMMENDED',
            count: '?'
          }
        },
        expandProperties: RULES_EXPAND_PROPERTIES
      })

      if (UserService.isFreemiumOrganization()) {
        $scope.model.selectedQuickFilter = {
          name: 'JAVA',
          filterType: 'JAVA',
          count: '?'
        }
      }
    }

    function init() {
      _setDefaults()
      $scope.model.busy = true
      _loadRules(0, $scope.model.numPerLoad)
      _getQuickFilters()
    }

    function _getQuickFilters() {
      if ($scope.model.quickFiltersPromise) {
        PromiseService.cancelPromise($scope.model.quickFiltersPromise)
      }

      $scope.model.quickFiltersPromise = RulesService.getQuickFilters(
        $scope.searchKeywords()
      )
        .then(function (filters) {
          $scope.model.quickFilters = filters
          $scope.model.selectedQuickFilter = $scope.model.quickFilters.find(
            function (filter) {
              return (
                filter.filterType == $scope.model.selectedQuickFilter.filterType
              )
            }
          )
        })
        .catch(ErrorService.processError)
    }

    function quickFilterSelect(filter) {
      $scope.model.busy = true
      $scope.model.rules = []
      $scope.model.selectedQuickFilter = filter
      _loadRules(0, $scope.model.numPerLoad)
    }

    function _loadRules(offset, limit) {
      if ($scope.model.rulesPromise) {
        PromiseService.cancelPromise($scope.model.rulesPromise)
      }

      var params = {
        quickFilter: $scope.model.selectedQuickFilter.filterType,
        q: $scope.searchKeywords(),
        limit: limit,
        offset: offset,
        sort: $scope.model.row,
        expand: $scope.expandProperties
      }

      $scope.model.rulesPromise = RulesService.get(params)
        .then(function (data) {
          $scope.model.rules = $scope.model.rules.concat(data.rules)
          $scope.model.busy = false
          $scope.model.count = data.count
          $timeout(function () {
            $scope.$emit('triggerScrollCheck')
          })

          var hasCustom = false

          _.each($scope.model.rules, function (rule) {
            if (
              !hasCustom &&
              (rule.customized_likelihood ||
                rule.customized_impact ||
                rule.customized_confidence)
            ) {
              hasCustom = true
              rule.isFirstCustom = true
            } else {
              rule.isFirstCustom = false
            }

            rule.isInAllLanguages = FeaturesService.isFeatureInAllLanguages(
              AGENT_FEATURE.ASSESS,
              rule.languages
            )

            rule.env_data = []
            _addRuleEnvData(
              rule.env_data,
              SERVER_ENVIRONMENT.DEVELOPMENT.value,
              rule.enabled_dev
            )
            _addRuleEnvData(
              rule.env_data,
              SERVER_ENVIRONMENT.QA.value,
              rule.enabled_qa
            )
            _addRuleEnvData(
              rule.env_data,
              SERVER_ENVIRONMENT.PRODUCTION.value,
              rule.enabled_prod
            )
          })
        })
        .catch(ErrorService.processError)
    }

    function _addRuleEnvData(envData, environment, enabled) {
      var ruleEnvData = {
        environment: environment,
        enabled: enabled
      }
      envData.push(ruleEnvData)
    }

    function searchKeywords(newSearchKeywords) {
      if (!arguments.length) {
        return _searchKeywords
      }

      if (newSearchKeywords !== _searchKeywords) {
        _searchKeywords = newSearchKeywords
      }

      $scope.model.busy = true
      $scope.model.rules = []
      _loadRules(0, $scope.model.numPerLoad)
      _getQuickFilters()

      return _searchKeywords
    }

    function loadRulesByScroll() {
      if (
        $scope.model.rules.length == $scope.model.count ||
        $scope.model.busy
      ) {
        return
      }

      $scope.model.busy = true
      $scope.scrollPromise = _loadRules(
        $scope.model.rules.length,
        $scope.model.numPerLoad
      )
      return $scope.scrollPromise
    }

    function order(rowName) {
      if ($scope.model.row === rowName) {
        return
      }

      $scope.model.busy = true
      $scope.model.rules = []
      $scope.model.row = rowName
      _loadRules(0, $scope.model.numPerLoad)
    }

    function changeStatus(rule, enabled, environment) {
      $scope.model.updating = true
      RulesService.updateStatus(rule, enabled, environment)
        .then(
          _updateRuleEnabled.bind({
            rule: rule,
            enabled: enabled,
            environment: environment
          })
        )
        .catch(ErrorService.processError)
        .finally(function () {
          $scope.model.updating = false
        })
    }

    // Update the matching rule inside $scope.model.rules
    function _updateRuleEnabled() {
      var rules = $scope.model.rules,
        i = 0,
        len = rules.length,
        rule
      for (; i < len; i++) {
        rule = rules[i]
        if (rule.name == this.rule.name) {
          var environment

          if (this.environment === SERVER_ENVIRONMENT.DEVELOPMENT.value) {
            environment = _.find(rule.env_data, {
              environment: SERVER_ENVIRONMENT.DEVELOPMENT.value
            })
            environment.enabled = this.enabled
          } else if (this.environment === SERVER_ENVIRONMENT.QA.value) {
            environment = _.find(rule.env_data, {
              environment: SERVER_ENVIRONMENT.QA.value
            })
            environment.enabled = this.enabled
          } else if (this.environment === SERVER_ENVIRONMENT.PRODUCTION.value) {
            environment = _.find(rule.env_data, {
              environment: SERVER_ENVIRONMENT.PRODUCTION.value
            })
            environment.enabled = this.enabled
          }
          return
        }
      }
    }

    function restoreDefaults(rule) {
      $scope.model.updating = true
      RulesService.restoreDefaults(rule)
        .then(function (response) {
          var severity = response.severity
          _restoreCustomized(rule, severity)
          _updateRuleCustomized(rule.name, severity)
        })
        .catch(ErrorService.processError)
        .finally(function () {
          $scope.model.updating = false
        })
    }

    function _updateRuleCustomized(ruleName, severity) {
      var rule = _.find($scope.model.rules, function (rule) {
        return rule.name == ruleName
      })
      _restoreCustomized(rule, severity)
    }

    function _restoreCustomized(rule, severity) {
      rule.customized_likelihood = false
      rule.customized_impact = false
      rule.customized_confidence = false
      rule.severity = severity
    }

    init()
  }
})()
